import { createRouter, createWebHashHistory } from 'vue-router'
import Results from './views/Results.vue'
import Login from './views/Login.vue'
import SurveyResults from './components/results/SurveyResults.vue'
// import DataExporter from './components/export/DataExporter.vue'
// import Comparison from './components/comparison/Comparison.vue'
import Tester from './tester/Tester.vue'
import { tabTypes } from './constants/tab-types'

const router = new createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'Results',
      component: Results,
      alias: '/results',
      meta: {
        authentication: true,
        title: 'Puls - Results'
      }
    },
    {
      path: '/:surveyName',
      name: tabTypes.RESULTS,
      component: SurveyResults
    },
    {
      path: '/comparison',
      name: tabTypes.COMPARISON,
      component: SurveyResults
    },
    {
      path: '/comparison/:surveyName',
      name: tabTypes.COMPARISON,
      component: SurveyResults
    },
    {
      path: '/export',
      name: tabTypes.EXPORT,
      component: SurveyResults
    },
    {
      path: '/export/:surveyName',
      name: tabTypes.EXPORT,
      component: SurveyResults
    },
    {
      path: '/freetext/:surveyName',
      name: tabTypes.FREETEXT,
      component: SurveyResults
    },
    {
      path: '/l/:surveyName',
      name: 'LoadingResults',
      redirect: (to) => {
        return { name: tabTypes.RESULTS, query: { load: true } }
      },
      meta: {
        title: 'Loading Puls Results'
      }
    },
    {
      path: '/tester',
      name: 'Tester',
      component: Tester
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Welcome to Puls!'
      }
    }
  ]
})

// TODO: Add useStore like this
// https://github.com/vuejs/pinia/discussions/971
router.beforeEach((to, from, next) => {
  // const userStore = useUserStore()
  // document.title = to.meta.title || 'Puls'
  // if (to.matched.some((record) => record.meta.authentication)) {
  //   if (!userStore.hasToken) {
  //     next({
  //       path: '/login'
  //     })
  //   } else {
  //     next()
  //   }
  // } else {
  next()
  // }
})

export default router
